module.exports = __webpack_public_path__ + "static/media/flag-ar.ec808ab0.webp";